import React from 'react';
import { useFeatureFlag } from '@harnessio/ff-react-client-sdk';

import { ANNUAL_BILLING } from '@app/constants/featureFlags';
import { PlanSelectionStepProps } from '../../types';
import { canUpdateToPlan } from '../../utils/planUtils';
import BillingFrequencyToggle from '../BillingFrequencyToggle/BillingFrequencyToggle';
import PlanCard from '../PlanCard/PlanCard';

import styles from './PlanSelectionStep.module.scss';

const PlanSelectionStep: React.FC<PlanSelectionStepProps> = ({
    billingFrequency,
    setBillingFrequency,
    plans,
    currentPlan,
    onPlanSelect,
    accountType
}) => {
    const isAnnualBillingEnabled = useFeatureFlag(ANNUAL_BILLING);

    return (
        <div className={styles.container}>
            <div className={styles.availablePlansSection}>
                <h2 className={styles.availablePlansTitle}>Available Plans</h2>
                {isAnnualBillingEnabled && (
                    <BillingFrequencyToggle
                        value={billingFrequency}
                        onChange={setBillingFrequency}
                        className={styles.billingToggle}
                    />
                )}
            </div>

            <div className={styles.plansList}>
                {plans.map((plan, index) => {
                    const isCurrent = plan.stripeId === currentPlan?.stripeId;
                    const isDisabled = isCurrent || !canUpdateToPlan(plan, currentPlan, accountType);
                    return (
                        <PlanCard
                            key={plan.stripeId || index}
                            plan={plan}
                            isCurrentPlan={isCurrent}
                            disabled={isDisabled}
                            billingFrequency={billingFrequency}
                            onSelect={() => onPlanSelect(plan)}
                            accountType={accountType}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default PlanSelectionStep;
